import React from 'react'
import { Context } from './Context'

/**
 *
 */
export const withCategory = (Component) => (props) => {
  const { category } = React.useContext(Context)
  return <Component category={category} {...props} />
}
